module.exports = __webpack_public_path__ + "img/QUIETMED2.2cd216b1.png";